import { publicClient, privateClient } from './client';
import { TotalValidate } from './TotalValidate';

const customTotalValidate = (pub: boolean) => new TotalValidate(pub ? publicClient : privateClient);
export default customTotalValidate;
